// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"f7f7ac8a","158":"756d8e90","209":"01fae2bc","244":"5cb0ab51","434":"df5e1754","718":"11d8238e","943":"9eef4b72"}[chunkId] + ".chunk.js";
};